import { render, staticRenderFns } from "./TrabalheConosco.vue?vue&type=template&id=c06d9abc&scoped=true&"
import script from "./TrabalheConosco.vue?vue&type=script&lang=js&"
export * from "./TrabalheConosco.vue?vue&type=script&lang=js&"
import style0 from "./TrabalheConosco.vue?vue&type=style&index=0&id=c06d9abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d9abc",
  null
  
)

export default component.exports